import $ from "jquery";
import "slick-carousel";

function initCustomerTestimonials() {
  if ($(".js-customer-testimonials").length) {
    const customerTestimonials = $(".js-customer-testimonials");

    customerTestimonials.slick({
      centerMode: true,
      centerPadding: "25%",
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: true,
      infinite: true,
      arrows: true,
      dots: false,
      nextArrow:
        '<button type="button" class="slick-next"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M13.9931 12L8.45277 5.42079L9.60015 4.45459L15.9541 12L9.60015 19.5454L8.45277 18.5792L13.9931 12Z" fill="white"/></svg></button>',
      prevArrow:
        '<button type="button" class="slick-prev"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.0069 12L15.5472 5.42079L14.3999 4.45459L8.0459 12L14.3999 19.5454L15.5472 18.5792L10.0069 12Z" fill="white"/></svg></button>',
      responsive: [
        {
          breakpoint: 1920,
          settings: {
            centerPadding: "20%",
          },
        },
        {
          breakpoint: 1600,
          settings: {
            centerPadding: "160px",
          },
        },
        {
          breakpoint: 768,
          settings: {
            arrows: false,
            centerPadding: "24px",
            variableWidth: false,
            infinite: false,
          },
        },
      ],
    });

    customerTestimonials.on(
      "afterChange",
      function (event, slick, currentSlide) {
        const dots = $(".customer-testimonials__slider-dot");
        dots.removeClass("active");
        dots.eq(currentSlide).addClass("active");
      }
    );

    const testimonialsHeight = $(".customer-testimonials").outerHeight();
    const statsHeight = $(".customer-testimonials__stats").outerHeight();
    const offsetHeight = testimonialsHeight - statsHeight;

    $(".customer-testimonials__slider-dots").css("top", offsetHeight + 20);
  }
}

// Run the function when the document is ready AND images are loaded
$(function () {
  initCustomerTestimonials();

  // Reinitialize slider on window resize
  let resizeTimer;
  $(window).on("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      if ($(".js-customer-testimonials").length) {
        $(".js-customer-testimonials").slick("unslick");
        initCustomerTestimonials();
      }
    }, 250);
  });
});
